import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  stageIssueList: [],
  isStageIssueLoading: false,
  isAddUpdateIssueInProgress: false,
  isDeleteIssueInProgress: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_STAGE_ISSUES_SUCCESS:
    case actionTypes.GET_STAGE_ISSUES_ERROR:
      if (action.payload.stageIssueList) {
        state.stageIssueList = action.payload.stageIssueList.map(task => {
          return {
            ...task,
            label: task.stageIssueName,
            value: task.uuid,
            open: false,
          };
        });
      } else {
        state.stageIssueList = [];
      }
      return Object.assign({}, state, state.stageIssueList);
    case actionTypes.TOOGLE_ACCORDIAN:
      state.stageIssueList = state.stageIssueList.map(stageIssue => {
        if (
          stageIssue.uuid === action.payload.taskId &&
          stageIssue.open === false
        ) {
          return {
            ...stageIssue,
            open: true,
          };
        } else {
          return {
            ...stageIssue,
            open: false,
          };
        }
      });
      return Object.assign({}, state, state.stageIssueList);
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.GET_STAGE_ISSUES:
          return Object.assign({}, state, { isStageIssueLoading: true });
        case actionTypes.CREATE_STAGE_ISSUE:
        case actionTypes.SAVE_STAGE_ISSUE:
          return Object.assign({}, state, { isAddUpdateIssueInProgress: true });
        case actionTypes.DELETE_STAGE_ISSUE:
          return Object.assign({}, state, { isDeleteIssueInProgress: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.GET_STAGE_ISSUES:
          return Object.assign({}, state, { isStageIssueLoading: false });
        case actionTypes.CREATE_STAGE_ISSUE:
        case actionTypes.SAVE_STAGE_ISSUE:
          return Object.assign({}, state, {
            isAddUpdateIssueInProgress: false,
          });
        case actionTypes.DELETE_STAGE_ISSUE:
          return Object.assign({}, state, { isDeleteIssueInProgress: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
